export default __webpack_public_path__ + "static/media/config-custom-fields-illustration.6f8db00d.jpg";